<div class="content">
  <div class="widget">

        <h2 class="pb-s">Umsatzkennzahlen</h2>
        <p>Hier können Sie Ihre aktuellen Umsatzkennzahlen einsehen.</p>

    <div *ngIf="revenue">
      <h2>{{ revenue.month | translate}} {{ today |date: 'YYYY' }}</h2>
      <p class="disclaimer">Stand: {{ today | date: 'dd.MM.YYYY'}} 03:42</p>
      <div class="row mt-s">
        <div class="col-sm-3">
          <div class="mb-s"><img src="/assets/img/icons/tiles/euro.svg" alt="Umsatz total"></div>
          <h4>Umsatz total</h4>
          <div class="revenue">
            {{ 182813.10 | currency:'EUR':'symbol':'1.2-2'}}
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-s"><img src="/assets/img/icons/tiles/packungen.svg" alt="Anzahl RX Packungen"></div>
          <h4>Anzahl RX Packungen <i class="fal fa-info-circle"
                                     matTooltip="inkl. Hochpreis"></i></h4>
          <div class="revenue" >
            {{ 3515 | number }}
          </div>
        </div>
        <div class="col-sm-2">
          <div class="mb-s"><img src="/assets/img/icons/tiles/packungen.svg" alt="Ist Spanne"></div>
          <h4>Ist Spanne</h4>
          <div class="revenue" >
            {{ 5.29 | number }} %
          </div>
        </div>
        <div class="col-sm-1">
          <div class="mb-s">
            <img src="/assets/img/icons/mein-umsatz-span.svg" style="visibility: hidden" alt="Entspricht">
          </div>
          <h4 style="visibility: hidden">Entspricht</h4>
          <div class="revenue">
            ≙
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-s">
            <img src="/assets/img/icons/tiles/rx_packungswert.svg" alt="RX Packungswert">
          </div>
          <h4>RX Packungswert <i class="fal fa-info-circle" matTooltip="Der dargestellte Wert entspricht dem ~ RX Packungswert zur ausgewiesenen Ist Spanne."></i>
          </h4>
          <div class="revenue">
            Ø 31,60 €
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="widget">
      <h2 class="pb-s">Monatlicher Umsatzverlauf</h2>

      <div class="loading-indicator" *ngIf="loading">
      <i class="fal fa-spinner-third fa-spin fa-7x"></i>
    </div>
      <mat-tab-group #tabGroup mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="loadRevenues($event)">
          <mat-tab label="Gesamt">
              <div class="chart" echarts [options]="options" (chartInit)="onChartInit($event)"></div>
              <div class="border-top" *ngIf="revenue">
                  <div class="container p-0">
                      <div class="row">
                          <div class="col-md-6 col-xs-12">
                          </div>
                          <div class="col-md-6 col-xs-12">
                              <div class="text-sm-left text-md-right">
                                  <h4 class="mb-2">Download</h4>
                                  <button class="btn-primary btn-round" >
                                      <span class="far fa-arrow-down"></span>
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="revenue" *ngIf="loading"><mat-icon class="icon-spin">progress_activity</mat-icon></div>
              </div>
          </mat-tab>
          <mat-tab label="PKP">
              <div class="chart" echarts [options]="options" (chartInit)="onChartInitPkp($event)"></div>
              <div class="border-top">
                  <div class="container p-0">
                      <div class="row">
                          <div class="col-md-6 col-xs-12">
                          </div>
                          <div class="col-md-6 col-xs-12">
                              <div class="text-sm-left text-md-right">
                                  <h4 class="mb-2">Download</h4>
                                  <button class="btn-primary btn-round" >
                                      <span class="far fa-arrow-down"></span>
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </mat-tab>
      </mat-tab-group>
  </div>
</div>
